<template>
  <div>
    <div class="goodItemCompont">
      <div class="goodPhoto">
        <img
          :class="member ? 'img1' : 'img2' "
          :src="member ? 'https://iqh-zt-pord-cdn.iqihang.com/ark-student-wap/member_gifts_h5.png' : goodsInfo.materialPicture"
          alt
        />
      </div>
      <span>{{member ? goodsInfo.name : goodsInfo.materialName}}</span>
    </div>
  </div>
</template>
<script>
// import { reqPackageName } from '@/api/courseDetail/shoppingCar/shoppingCar';

export default {
  props: {
    goodsInfo: {
      type: Object,
      default: () => {},
    },
    member: {
      type: Boolean,
      default: false,
    },
  },
  components: {},

  data() {
    return {
      name: '',
    };
  },
  methods: {},
  mounted() {
    // if (this.member) {
    //   reqPackageName([this.goodsInfo.giftPackageId]).then(res => {
    //     this.name = res?.data[0]?.name || '';
    //   });
    // }
  },
};
</script>

<style scoped lang="scss">
.goodItemCompont {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  padding: 22px;
  background: #fff;
  border-radius: 14px;
  .goodPhoto {
    width: 119px;
    height: 119px;
    margin-right: 22px;
    overflow: hidden;
    background: #fff;
    border: 2px solid #efefef;
    border-radius: 14px;
    .img1 {
      width: 101px;
      height: 76px;
      margin-top: 22px;
      margin-left: 9px;
    }
    .img2 {
      width: 119px;
      height: 119px;
      // margin-top: 20px;
      // margin-left: 5;
    }
  }
  span {
    flex: 1;
    color: #333;
    font-weight: 500;
    font-size: 29px;
    line-height: 40px;
  }
}
</style>
